import * as tslib_1 from "tslib";
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadConsumerMailboxOptions from './loadConsumerMailboxOptions';
import { action } from 'satcheljs/lib/legacy';
import { getAliasAddresses, getConnectedAccounts, shouldSkipEmailAddress, } from '../utils/getFromAddresses';
export default action('toggleFromContextMenu')(function toggleFromContextMenu(viewState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userConfig, sendAsAddresses, primaryAddress;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    viewState.isFromContextMenuShown = !viewState.isFromContextMenuShown;
                    if (!viewState.isFromContextMenuShown) return [3 /*break*/, 3];
                    if (!(isConsumer() && viewState.loadAliasActionStatus == 0 /* NotStarted */)) return [3 /*break*/, 2];
                    viewState.loadAliasActionStatus = 1 /* Started */;
                    return [4 /*yield*/, loadConsumerMailboxOptions()];
                case 1:
                    _a.sent();
                    viewState.loadAliasActionStatus = 2 /* Finished */;
                    _a.label = 2;
                case 2:
                    userConfig = getUserConfiguration();
                    sendAsAddresses = [];
                    primaryAddress = userConfig.SessionSettings.UserEmailAddress;
                    if (!shouldSkipEmailAddress(primaryAddress)) {
                        sendAsAddresses.push(primaryAddress);
                    }
                    // Add alias for consumer users
                    if (isConsumer()) {
                        sendAsAddresses = sendAsAddresses.concat(getAliasAddresses(primaryAddress));
                    }
                    // Add connected accounts
                    sendAsAddresses = getConnectedAccounts(sendAsAddresses);
                    viewState.sendAsEmailAddresses = sendAsAddresses;
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=toggleFromContextMenu.js.map